import React from 'react'
import PropTypes from 'prop-types'
import IconButton from '@material-ui/core/IconButton'
import Select from '@material-ui/core/Select'
import { MenuItem } from '@material-ui/core'
import connectPropTypes from '../utilities/connectPropTypes'
import styles from './FilterBar.icss'
import displayModes, { allDisplayModes } from '../enums/displayModes'

class FilterBar extends React.Component {
	static getDerivedStateFromProps(props, prevState) {
		const newState = {}
		if (!prevState.selected) {
			newState.selected = props.displayMode
		}
		if (!prevState.filter) {
			newState.filter = props.filterDefault || (props.filterOptions.length > 0 ? props.filterOptions[0].value : undefined)
		}
		return newState
	}

	constructor(props) {
		super(props)

		this.state = {
			selected: props.displayMode,
			filter: props.filterDefault || (props.filterOptions.length > 0 ? props.filterOptions[0].value : undefined)
		}

		this.handleClickBinder = this.handleClickBinder.bind(this)
		this.handleFilterChange = this.handleFilterChange.bind(this)
	}

	//  Ability to handle click for a selected items
	handleClickBinder(value) {
		return () => {
			this.setState((state) => {
				if (state.selected !== value) {
					this.props.setDisplayMode(value)
					return { selected: value }
				}
				return null
			})
		}
	}

	handleFilterChange(event) {
		this.setState({ filter: event.target.value })
		this.props.onFilterChange(event.target.value)
	}

	render() {
		const { allowedDisplayModes, filterOptions } = this.props
		const showFilter = filterOptions.length > 0
		const showModes = allowedDisplayModes.length > 1
		return showFilter || showModes ? (
			<section className={styles.filterBar}>
				{filterOptions.length > 0 ? (
					<Select
						className={styles.select}
						value={this.state.filter}
						onChange={this.handleFilterChange}
						inputProps={{
							name: 'filter',
							id: 'filter'
						}}
					>
						{filterOptions.map(filterOption => (
							<MenuItem key={filterOption.name} value={filterOption.value}>
								{filterOption.name}
							</MenuItem>
						))}
					</Select>
				) : <div />}

				{allowedDisplayModes.length > 1 ? (
					<div className={styles.buttons}>
						{allowedDisplayModes.map((displayModeType) => {
							const DisplayModeIcon = this.state.selected === displayModeType ? displayModes[displayModeType].iconActive : displayModes[displayModeType].icon
							return (
								<IconButton
									key={displayModeType}
									onClick={this.handleClickBinder(displayModeType)}
								>
									{DisplayModeIcon}
								</IconButton>
							)
						})}
					</div>
				) : <div />}
			</section>
		) : null
	}
}

FilterBar.propTypes = {
	setDisplayMode: PropTypes.func.isRequired,
	displayMode: PropTypes.oneOf(Object.keys(displayModes).map(mode => displayModes[mode].type)),
	allowedDisplayModes: PropTypes.arrayOf(PropTypes.oneOf(Object.keys(displayModes).map(mode => displayModes[mode].type))),
	filterOptions: PropTypes.array, // eslint-disable-line react/forbid-prop-types
	onFilterChange: PropTypes.func,
	filterDefault: PropTypes.any // eslint-disable-line react/forbid-prop-types
}

FilterBar.defaultProps = {
	displayMode: displayModes.LIST.type,
	allowedDisplayModes: allDisplayModes,
	filterOptions: [],
	onFilterChange: () => null,
	filterDefault: undefined
}

export const testing = {
	FilterBar
}

export default connectPropTypes(FilterBar)



// WEBPACK FOOTER //
// ./src/components/FilterBar.jsx